import { mapChannelGroupFromSysApi } from '@shure/shared/angular/data-access/system-api/mappers';

import { LimiterChannel } from '../../api';
import { LimiterChannelFragment } from '../graphql/generated/limiter.generated';

export function mapLimiterChannelFromSysApi(channel: LimiterChannelFragment): LimiterChannel {
	const { id, description, features } = channel;
	return {
		id,
		name: channel.features.name?.name,
		group: mapChannelGroupFromSysApi(channel.description.groupName),
		constraints: {
			threshold: {
				min: description.constraints.limiter?.threshold.range
					? description.constraints.limiter?.threshold.range?.min
					: 0,
				max: description.constraints.limiter?.threshold.range
					? description.constraints.limiter?.threshold.range?.max
					: 0,
				step: description.constraints.limiter?.threshold.range
					? description.constraints.limiter?.threshold.range?.step
					: 0
			}
		},
		features: {
			limiter: {
				enabled: features.limiter?.enabled || false,
				threshold: {
					threshold: features.limiter?.threshold || 0,
					isMissing: !description.constraints.limiter?.threshold.supported
				}
			},
			channelConfiguration: channel.description.features.channelConfiguration.supported
				? {
						enabled: channel.features.channelConfiguration?.enabled || false,
						isMissing: channel.features.channelConfiguration === null
				  }
				: undefined
		}
	};
}
